import React, { useState, useEffect, useRef } from "react";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import HeaderWebComponent from "./HeaderWebComponent";
import ErrorPage from "../ErrorPage";
import { appByLanding, incrementAnalyticsCount } from "apis";
import { isMobileDevice, withRedux, SecureLocalStorage } from "helpers";
import WebPageController from "./WebTemplates/WebPageController";
import { useScrollPosition } from "./useScrollPosition";

import { ToastContainer, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "react-emotion";
import { HasPermission } from "components";

const bodyStyle = css`
  width: 100%;
`;
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

function HomeWebComponent(props) {
  // console.dir(props.history);
  // console.dir(props.userApplicationsPermissions);
  const path = props.history.location.pathname;
  // console.log(path);
  const isAdmin = new URLSearchParams(window.location.search).get("isAdmin");
  // console.log(isAdmin);

  const landingPagePath = path.replace("/home", "").replace("/", "");

  const activeTemplate = props.activeTemplate;

  const [app, setApp] = useState(null);
  const [appId, setAppId] = useState(
    props.history.location.state ? props.history.location.state.id : null
  );
  const [userId, setUserId] = useState(
    localStorage.getItem("userId") ? localStorage.getItem("userId") : null
  );
  const [view, setView] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [hideOnScroll, setHideOnScroll] = useState(true);

  const isMob = isMobileDevice();

  // console.log("AT WEB HOME");

  // const adminId = localStorage.getItem("currentAdminId");

  // console.log(appId);
  // console.log(userId);
  // console.log(adminId);

  const getAppByLanding = async () => {
    try {
      // console.log("getting app by landing page path.....");
      // console.log(landingPagePath);
      const result = await appByLanding(landingPagePath);
      return result;
    } catch (e) {
      console.error(e);
      setErrorMessage("Oops! This page does not exist!");
    }
  };
  const getWebAppData = async () => {
    try {
      // TODO: Handle session user
      if (!appId) {
        getAppByLanding().then((app) => {
          setApp(app);
          setAppId(app.id);
          props.actions.removeCart();
          if (!props.platformInfo.status.user.tempUser) {
            // console.log("user object:");
            // console.dir(props.platformInfo.status.user);
            props.actions.updateCustomerInfo({
              firstName: props.platformInfo.status.user.firstName,
              lastName: props.platformInfo.status.user.lastName,
              email: props.platformInfo.status.user.email,
              phone: props.platformInfo.status.user.phone,
            });
          }
        });
        return;
      }
      if (!errorMessage || appId) {
        const result = await props.actions.webFeatureLogin(appId, userId);
        // console.dir(result);

        // props.actions.setUser(result.user);
        const view = JSON.parse(
          decodeURI(
            result.application.publishedView !== null
              ? result.application.publishedView
              : result.application.unpublishedView
          )
        );

        const appState = { view, ...result.application };
        // props.actions.setApplication(cloneDeep(appState));

        setApp(result.application);

        setView(view);
        const user = result.user;
        // console.dir(user);
        setUserId(user.id);

        const analyticsResult = await incrementAnalyticsCount(
          appId,
          user.id,
          "WEBSITE_OPENED"
        );
        // console.dir(analyticsResult);
        SecureLocalStorage.setItem("userId", user.id);

        // If anon user, set platform.status.user
        // props.actions.login(user);
      }
    } catch (e) {
      console.error(e);
      setView(null);
      setErrorMessage("Oops! This does not have web enabled!");
    }
  };

  // ComponentDidUpdate
  useEffect(() => {
    getWebAppData();
  }, [appId]);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
    false,
    false,
    350
  );

  // useEffect(() => {
  //   props.actions.removeCart();
  // }, [userId]);
  // console.dir(history);
  if (!view && !errorMessage) return null;
  if (app && !app.websiteEnabled) {
    if (!isAdmin) {
      props.history.push(`/${landingPagePath}`);
      return null;
    }
  }
  if (errorMessage) return <ErrorPage errorMessage={errorMessage} />;
  else {
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: view.navigation.navBarColor,
        },
      },
    });
    return (
      <ThemeProvider theme={theme}>
        {isAdmin ? (
          <HasPermission
            requiredPermissions={[0, 1, 2, 3]}
            fallback={
              <p>You don’t have permissions to view this web preview.</p>
            }
          >
            {" "}
            <div
              className={styles.body}
              style={{
                display: "flex",
                flexDirection: "column",
                overflowX: "hidden",
                top: "0",
              }}
            >
              <HeaderWebComponent
                history={props.history}
                nav={view.navigation}
                show={hideOnScroll}
                isAdmin={isAdmin}
              />

              <WebPageController {...props} isAdmin={isAdmin} />
              <div>
                <ToastContainer
                  position="bottom-center"
                  autoClose={2000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable={false}
                  pauseOnHover
                  transition={Zoom}
                  bodyClassName={bodyStyle}
                />
              </div>
              <Footer />
            </div>
          </HasPermission>
        ) : (
          <div
            className={styles.body}
            style={{
              display: "flex",
              flexDirection: "column",
              overflowX: "hidden",
              top: "0",
            }}
          >
            <HeaderWebComponent
              history={props.history}
              nav={view.navigation}
              show={hideOnScroll}
              isAdmin={isAdmin}
            />

            <WebPageController {...props} isAdmin={isAdmin} />
            <div>
              <ToastContainer
                position="bottom-center"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                transition={Zoom}
                bodyClassName={bodyStyle}
              />
            </div>
            <Footer />
          </div>
        )}
      </ThemeProvider>
    );
  }
}

export default withRedux(HomeWebComponent);
